import { LegalPageLayout } from './LegalPageLayout';

export function ChiSiamoPage() {
  return (
    <LegalPageLayout title="Chi Siamo">
      <p className="mt-2 text-sm text-neutral-500">Ultima revisione: 7 Maggio 2026</p>
                  
                    <h2>Il Nostro Valore Fondamentale</h2>
                    <p>
                      Siamo il punto di riferimento professionale ed etico di cui hai bisogno, garantito dalla qualità
                      e dalla trasparenza. La nostra filosofia è basata sulla fusione di chiarezza e saggezza, la
                      stessa dualità che si riflette nel nostro nome.
                    </p>
                    <p>
                      In un mondo in cui le risposte sembrano sempre più confuse, Klaro7 nasce per offrire un
                      punto di riferimento lucido e affidabile, un ponte tra l&apos;intuizione e l&apos;azione concreta.
                    </p>
                    <p>
                      <strong>La Nostra Missione:</strong> Fornire una consulenza etica e di alta qualità, trasformando il mistero in
                      chiarezza e la curiosità in crescita personale. Crediamo che ogni individuo meriti una guida
                      onesta e competente per prendere decisioni consapevoli riguardo al proprio futuro, all&apos;amore
                      e al lavoro.
                    </p>
      
                    <h2>La Nostra Storia</h2>
                    <p>
                      <strong>Il Problema:</strong> Abbiamo notato che il mondo della consulenza esoterica online era pieno di
                      confusione, servizi non verificati e, purtroppo, truffe. Questo ha generato sfiducia e
                      frustrazione nelle persone che cercavano solo risposte oneste.
                    </p>
                    <p>
                      <strong>La Soluzione (La Nascita di Klaro7):</strong> Per questo, abbiamo creato Klaro7: una piattaforma
                      nata dall&apos;esigenza di professionalizzare il settore. Siamo stati fondati da un gruppo di
                      professionisti esperti, uniti dall&apos;obiettivo di elevare lo standard etico della cartomanzia
                      online. Non siamo qui per venderti un&apos;illusione, ma per offrirti una consulenza di alto livello,
                      supportata da una selezione rigorosa e da un ambiente sicuro.
                    </p>
      
                    <h2>Perché Scegliere Klaro7</h2>
      
                    <h3>1. Selezione Rigorosa</h3>
                    <p>
                      «Solo Veri Professionisti al Tuo Servizio»: Siamo gli unici a garantire un processo di
                      selezione a tre livelli per i nostri consulenti. Questo processo include la verifica
                      dell&apos;esperienza, un test pratico di lettura e l&apos;accettazione del nostro rigoroso Codice Etico. Il
                      nostro team è composto solo da professionisti esperti, molti dei quali con almeno un
                      quinquennio di esperienza nel settore, un requisito chiave per garantire la massima
                      competenza.
                    </p>
      
                    <h3>2. Trasparenza Etica</h3>
                    <p>
                      «Etica e Onestà al Primo Posto»: La nostra attività è fondata sulla massima trasparenza. I
                      nostri esperti operano seguendo un rigoroso Codice Etico che vieta ogni pratica scorretta,
                      come l&apos;abuso della credulità popolare o l&apos;induzione a servizi non necessari (&quot;rimozione di
                      maledizioni&quot;). <strong>La Nostra Garanzia:</strong> Garantiamo che ogni consulto sia fornito in modo
                      onesto, nel rispetto del tuo benessere e della tua privacy.
                    </p>
      
                    <h3>3. Disponibilità e Accessibilità</h3>
                    <p>
                      «Il Tuo Supporto, Sempre Disponibile»: Sappiamo che le domande importanti non
                      aspettano. Per questo, la nostra piattaforma e i nostri consulenti sono disponibili 24 ore su
                      24, 7 giorni su 7. Puoi trovare risposta immediata quando ne hai più bisogno, attraverso
                      consulti in <strong>Chiamata, Chat, o in Videochiamata</strong> (solo con i consulenti abilitati al
                      servizio).
                    </p>
      
                    <h3>4. Un Punto di Incontro</h3>
                    <p>
                      «Chiarezza e Fortuna uniti nel 7»: Il nostro nome, Klaro7, simboleggia la nostra missione:
                      fornire Chiarezza (Klaro) per guidarti verso la Perfezione e la Saggezza (simbolismo del 7).
                      Siamo un ponte tra la logica e l&apos;intuizione, tra il tuo presente e le tue potenzialità future.
                    </p>
      
                    <h2>La Promessa di Klaro7</h2>
                    <p>
                      Oggi, siamo l&apos;unica piattaforma in grado di garantire che le tue domande più profonde
                      riceveranno risposte da professionisti verificati, offrendo la serenità di un consulto etico.
                    </p>
    </LegalPageLayout>
  );
}
